// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    GetReviewIntelligentPartnerCourseScoresQuery,
    BaseResponseListReviewIntelligentPartnerCourseScoreFoundResponse,
    PostReviewIntelligentPartnerCourseScoresBody,
    BaseResponseReviewIntelligentPartnerCourseScoreFoundResponse,
} from '../types';

/**
 * findAll
 *
 * @export
 * @tags review-intelligent-partner-course-score-controller
 * @link [GET] /reviewIntelligentPartnerCourseScores
 */
export function getReviewIntelligentPartnerCourseScores(): Promise<BaseResponseListReviewIntelligentPartnerCourseScoreFoundResponse>;
export function getReviewIntelligentPartnerCourseScores(
    options: ApiOptions<never, GetReviewIntelligentPartnerCourseScoresQuery>
): Promise<BaseResponseListReviewIntelligentPartnerCourseScoreFoundResponse>;
export function getReviewIntelligentPartnerCourseScores(
    options?: ApiOptions<never, GetReviewIntelligentPartnerCourseScoresQuery>
): Promise<BaseResponseListReviewIntelligentPartnerCourseScoreFoundResponse> {
    return request<never, never, GetReviewIntelligentPartnerCourseScoresQuery>(
        '/reviewIntelligentPartnerCourseScores',
        {
            ...options,
            method: 'get',
            __$requestCalleeName: 'getReviewIntelligentPartnerCourseScores',
        }
    );
}

/**
 * save
 *
 * @export
 * @tags review-intelligent-partner-course-score-controller
 * @link [POST] /reviewIntelligentPartnerCourseScores
 */
export function postReviewIntelligentPartnerCourseScores(
    data: PostReviewIntelligentPartnerCourseScoresBody
): Promise<BaseResponseReviewIntelligentPartnerCourseScoreFoundResponse>;
export function postReviewIntelligentPartnerCourseScores(
    data: PostReviewIntelligentPartnerCourseScoresBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseReviewIntelligentPartnerCourseScoreFoundResponse>;
export function postReviewIntelligentPartnerCourseScores(
    data: PostReviewIntelligentPartnerCourseScoresBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseReviewIntelligentPartnerCourseScoreFoundResponse> {
    return request<PostReviewIntelligentPartnerCourseScoresBody, never, never>(
        '/reviewIntelligentPartnerCourseScores',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postReviewIntelligentPartnerCourseScores',
        }
    );
}

export const meta = [
    {
        tags: ['review-intelligent-partner-course-score-controller'],
        path: '/reviewIntelligentPartnerCourseScores',
        method: 'get',
    },
    {
        tags: ['review-intelligent-partner-course-score-controller'],
        path: '/reviewIntelligentPartnerCourseScores',
        method: 'post',
    },
];
